import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/customListCommand/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemCommand({ id, params }) {
  return request(`/customListCommand/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewCommand(params) {
  return request.post('/customListCommand', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/customListCommand/${id}`, {});
}
